export default __webpack_public_path__ + "static/media/clock.e9a72c9a.svg";